export function shouldClearMicSilent(opts: { muted: boolean; stillSilent: boolean }): boolean {
  return !opts.muted && !opts.stillSilent
}

export const MIC_SILENT_CONFIRM_MS = 3000

export function shouldAssertMicSilent(opts: { muted: boolean; stillSilent: boolean }): boolean {
  return !opts.muted && opts.stillSilent
}
